import { useEffect, useState } from "react";
import { getPreferences, updatePreferences } from "./mainPanel.service";

export const useMainPanel = () => {
  const [pageIsLoaded, setPageIsLoaded] = useState(false);
  const [invalidToken, setInvalidToken] = useState(false);

  const [subToken, setSubToken] = useState<string>("");

  const [emailAddress, setEmailAddress] = useState<string>("");

  const [businessIsChecked, setBusinessIsChecked] = useState<boolean>(false);
  const [leisureIsChecked, setLeisureIsChecked] = useState<boolean>(false);

  const [horseguardsSubIsChecked, setHorseguardsSubIsChecked] =
    useState<boolean>(false);
  const [towerSubIsChecked, setTowerSubIsChecked] = useState<boolean>(false);
  const [theClermontSubIsChecked, setTheClermontSubIsChecked] =
    useState<boolean>(false);
  const [thistleHotelsSubIsChecked, setThistleHotelsSubIsChecked] =
    useState<boolean>(false);
  const [marbleArchSubIsChecked, setMarbleArchSubIsChecked] =
    useState<boolean>(false);
  const [allHotelsSubIsChecked, setAllHotelsSubIsChecked] =
    useState<boolean>(false);
  const [allRestaurantsSubIsChecked, setAllRestaurantsSubIsChecked] =
    useState<boolean>(false);
  const [theCumberlandSubIsChecked, setTheCumberlandSubIsChecked] =
    useState<boolean>(false);

  const [soundSubIsChecked, setSoundSubIsChecked] = useState<boolean>(false);
  const [hellsKitchenSubIsChecked, setHellsKitchenSubIsChecked] = useState<boolean>(false);
  const [vicinitySubIsChecked, setVicinitySubIsChecked] =
    useState<boolean>(false);
  const [soakSubIsChecked, setSoakSubIsChecked] = useState<boolean>(false);
  const [towerVUSubIsChecked, setTowerVUSubIsChecked] = useState<boolean>(false);

  const [acceptPrivacyPolicyIsChecked, setAcceptPrivacyPolicyIsChecked] =
    useState<boolean>(false);
  const [noLongerReceiveIsChecked, setNoLongerReceiveIsChecked] =
    useState<boolean>(false);

  const [submittedPreferences, setSubmittedPreferences] = useState(false);

  useEffect(() => {
    setPageIsLoaded(false);

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token") ?? "";

    if (!token || token?.length === 0) {
      setSubToken("");
      populateTokenPreference("");

      setInvalidToken(true);
      setPageIsLoaded(true);

      return;
    }

    setSubToken(token);
    populateTokenPreference(token);
  }, []);

  const populateTokenPreference = async (token: string) => {
    const preferences = await getPreferences(token);

    //console.log(preferences);

    if (!preferences || !preferences.length) {
      setInvalidToken(true);
      setPageIsLoaded(true);
      return;
    }

    const preference = preferences[0];

    if (!Object.keys(preference).includes("Preferences")) {
      setInvalidToken(true);
      return;
    }

    if (!Object.keys(preference.Preferences).includes("Email")) {
      setInvalidToken(true);
      return;
    }

    const b2cInterefestsPrefs = preference.Preferences.B2C_Interests;
    const emailPrefs = preference.Preferences.Email;

    const isBusiness: boolean = b2cInterefestsPrefs?.Business === "Y";
    const isLeisure: boolean = b2cInterefestsPrefs?.Leisure === "Y";

    const isSubToClermont: boolean = emailPrefs?.Clermont === "Y";
    const isSubToHorseguards: boolean = emailPrefs?.Horseguards === "Y";
    const isSubToTower: boolean = emailPrefs?.Tower === "Y";
    const isSubToThistle: boolean = emailPrefs?.Thistle === "Y";
    const isSubToMarbleArch: boolean = emailPrefs?.["Marble Arch"] === "Y";
    const isSubToCumberland: boolean = emailPrefs?.Cumberland === "Y";
    const isSubToSound: boolean = emailPrefs?.Sound === "Y";
    const isSubToHellsKitchen: boolean = emailPrefs?.["Hells Kitchen"] === "Y";
    const isSubToVicinity: boolean = emailPrefs?.Vicinity === "Y";
    const isSubToSoak: boolean = emailPrefs?.Soak === "Y";
    const isSubToTowerVU: boolean = emailPrefs?.["Tower VU"] === "Y";

    setBusinessIsChecked(isBusiness);
    setLeisureIsChecked(isLeisure);

    setTheClermontSubIsChecked(isSubToClermont);
    setHorseguardsSubIsChecked(isSubToHorseguards);
    setTowerSubIsChecked(isSubToTower);
    setThistleHotelsSubIsChecked(isSubToThistle);
    setMarbleArchSubIsChecked(isSubToMarbleArch);

    setAllHotelsSubIsChecked(
      isSubToClermont &&
      isSubToHorseguards &&
      isSubToTower &&
      isSubToThistle &&
      isSubToCumberland &&
      isSubToMarbleArch
    );
    setAllRestaurantsSubIsChecked(
      isSubToSound &&
      isSubToVicinity &&
      isSubToSoak &&
      isSubToTowerVU &&
      isSubToHellsKitchen
    );
    setTheCumberlandSubIsChecked(isSubToCumberland);

    setSoundSubIsChecked(isSubToSound);
    setHellsKitchenSubIsChecked(isSubToHellsKitchen);
    setVicinitySubIsChecked(isSubToVicinity);
    setSoakSubIsChecked(isSubToSoak);
    setTowerVUSubIsChecked(isSubToTowerVU)

    setEmailAddress(preference.email);

    setPageIsLoaded(true);
  };

  const subClick = (subType: string) => {
    let clermontSubChecked: boolean = theClermontSubIsChecked;
    let allHotelsSubChecked: boolean = allHotelsSubIsChecked;
    let allRestaurantsSubChecked: boolean = allRestaurantsSubIsChecked;
    let thistleSubChecked: boolean = thistleHotelsSubIsChecked;
    let marbleArchSubChecked: boolean = marbleArchSubIsChecked;
    let cumberlandSubChecked: boolean = theCumberlandSubIsChecked;
    let soundSubChecked: boolean = soundSubIsChecked;
    let hellsKitchenSubChecked: boolean = hellsKitchenSubIsChecked;
    let vicinitySubChecked: boolean = vicinitySubIsChecked;
    let soakSubChecked: boolean = soakSubIsChecked;
    let towerVUSubChecked: boolean = towerVUSubIsChecked;
    let horseguardsSubChecked: boolean = horseguardsSubIsChecked;
    let towerSubChecked: boolean = towerSubIsChecked;

    switch (subType.toLocaleLowerCase()) {
      case "clermont":
        clermontSubChecked = !clermontSubChecked;

        setTheClermontSubIsChecked(clermontSubChecked);
        checkAllHotelsClicked();

        break;

      case "allhotels":
        allHotelsSubChecked = !allHotelsSubChecked;

        setTheClermontSubIsChecked(allHotelsSubChecked);
        setTheCumberlandSubIsChecked(allHotelsSubChecked);
        setAllHotelsSubIsChecked(allHotelsSubChecked);
        setThistleHotelsSubIsChecked(allHotelsSubChecked);
        setMarbleArchSubIsChecked(allHotelsSubChecked);
        setTowerSubIsChecked(allHotelsSubChecked);
        setHorseguardsSubIsChecked(allHotelsSubChecked);

        break;

      case "allrestaurants":
        allRestaurantsSubChecked = !allRestaurantsSubChecked;

        setSoundSubIsChecked(allRestaurantsSubChecked)
        setVicinitySubIsChecked(allRestaurantsSubChecked)
        setSoakSubIsChecked(allRestaurantsSubChecked)
        setTowerVUSubIsChecked(allRestaurantsSubChecked)
        setHellsKitchenSubIsChecked(allRestaurantsSubChecked)
        setAllRestaurantsSubIsChecked(allRestaurantsSubChecked)

        break;

      case "thistle":
        thistleSubChecked = !thistleSubChecked;

        setThistleHotelsSubIsChecked(thistleSubChecked);
        checkAllHotelsClicked();

        break;

      case "marble arch":
        marbleArchSubChecked = !marbleArchSubChecked;

        setMarbleArchSubIsChecked(marbleArchSubChecked);
        checkAllHotelsClicked();

        break;

      case "cumberland":
        cumberlandSubChecked = !cumberlandSubChecked;

        setTheCumberlandSubIsChecked(cumberlandSubChecked);
        checkAllHotelsClicked();

        break;

      case "sound":
        soundSubChecked = !soundSubChecked;
        setSoundSubIsChecked(soundSubChecked);
        checkAllRestaurantsClicked();
        break;

      case "hells kitchen":
        hellsKitchenSubChecked = !hellsKitchenSubChecked;
        setHellsKitchenSubIsChecked(hellsKitchenSubChecked);
        checkAllRestaurantsClicked();
        break;

      case "vicinity":
        vicinitySubChecked = !vicinitySubChecked;
        setVicinitySubIsChecked(vicinitySubChecked);
        checkAllRestaurantsClicked();
        break;

      case "soak":
        soakSubChecked = !soakSubChecked;
        setSoakSubIsChecked(soakSubChecked);
        checkAllRestaurantsClicked();
        break;

      case "tower vu":
        towerVUSubChecked = !towerVUSubChecked;
        setTowerVUSubIsChecked(towerVUSubChecked);
        checkAllRestaurantsClicked();
        break;

      case "horseguards":
        horseguardsSubChecked = !horseguardsSubChecked;
        setHorseguardsSubIsChecked(horseguardsSubChecked);
        checkAllHotelsClicked();

        break;

      case "tower":
        towerSubChecked = !towerSubChecked;
        setTowerSubIsChecked(towerSubChecked);
        checkAllHotelsClicked();

        break;
    }

    function checkAllHotelsClicked() {
      setAllHotelsSubIsChecked(
        clermontSubChecked &&
        thistleSubChecked &&
        cumberlandSubChecked &&
        towerSubChecked &&
        horseguardsSubChecked
      );
    }
    function checkAllRestaurantsClicked() {
      setAllRestaurantsSubIsChecked(
        soundSubChecked &&
        vicinitySubChecked &&
        soakSubChecked &&
        towerVUSubChecked &&
        hellsKitchenSubChecked
      );
    }
  };

  const submitUpdatePreferences = async () => {
    let preferences = {
      Clermont: theClermontSubIsChecked ? "Y" : "N",
      Thistle: thistleHotelsSubIsChecked ? "Y" : "N",
      "Marble Arch": marbleArchSubIsChecked ? "Y" : "N",
      Cumberland: theCumberlandSubIsChecked ? "Y" : "N",
      Sound: soundSubIsChecked ? "Y" : "N",
      "Hells Kitchen": hellsKitchenSubIsChecked ? "Y" : "N",
      Vicinity: vicinitySubIsChecked ? "Y" : "N",
      Soak: soakSubIsChecked ? "Y" : "N",
      Tower: towerSubIsChecked ? "Y" : "N",
      Horseguards: horseguardsSubIsChecked ? "Y" : "N",
      "Tower VU": towerVUSubIsChecked ? "Y" : "N",
    };

    let interests = {
      business: businessIsChecked ? "Y" : "N",
      leisure: leisureIsChecked ? "Y" : "N",
    };

    let newPreferences = {
      unsub_token: subToken,
      date_stamp: new Date().toLocaleString("sv"),
      preferences: preferences,
      interests: interests,
    };

    await updatePreferences(newPreferences);
    //console.log("newPreferences", newPreferences)
    setSubmittedPreferences(true);
  };

  const setUnsubCheckboxStates = () => {
    setBusinessIsChecked(false);
    setLeisureIsChecked(false);

    setTheClermontSubIsChecked(false);
    setAllHotelsSubIsChecked(false);
    setAllRestaurantsSubIsChecked(false);
    setThistleHotelsSubIsChecked(false);
    setMarbleArchSubIsChecked(false);
    setTheCumberlandSubIsChecked(false);
    setHorseguardsSubIsChecked(false);
    setTowerSubIsChecked(false);

    setSoundSubIsChecked(false);
    setHellsKitchenSubIsChecked(false);
    setVicinitySubIsChecked(false);
    setSoakSubIsChecked(false);
    setTowerSubIsChecked(false)

    setAcceptPrivacyPolicyIsChecked(false);

    setNoLongerReceiveIsChecked(!noLongerReceiveIsChecked);
  };

  const unsubscribeClick = async () => {
    let preferences = {
      Clermont: "N",
      Guoman: "N",
      Thistle: "N",
      "Marble Arch": "N",
      Cumberland: "N",
      Sound: "N",
      "Hells Kitchen": "N",
      Vicinity: "N",
      Soak: "N",
      Tower: "N",
      Horseguards: "N",
      "Tower VU": "N",
    };

    let interests = {
      business: businessIsChecked ? "Y" : "N",
      leisure: leisureIsChecked ? "Y" : "N",
    };

    let newPreferences = {
      unsub_token: subToken,
      date_stamp: new Date().toLocaleString("sv"),
      preferences: preferences,
      interests: interests,
    };

    const options = {
      headers: {
        authstring: "5df6c913-d041-41d3-9635-ece880dd3ba2",
      },
    };

    await updatePreferences(newPreferences);
    //console.log("newPreferences",newPreferences)

    setSubmittedPreferences(true);
  };

  const openPrivacyPolicy = () => {
    window.open(
      "https://www.clermonthotel.group/legals#privacypolicy",
      "Privacy Policy",
      "height=720,width=960,toolbar=no,menubar=no,scrollbars=no,location=no,status=no"
    );
  };

  return {
    pageIsLoaded,
    invalidToken,
    emailAddress,

    businessIsChecked,
    setBusinessIsChecked,
    leisureIsChecked,
    setLeisureIsChecked,

    noLongerReceiveIsChecked,
    subClick,

    towerSubIsChecked,
    horseguardsSubIsChecked,
    theClermontSubIsChecked,
    allHotelsSubIsChecked,
    thistleHotelsSubIsChecked,
    marbleArchSubIsChecked,
    theCumberlandSubIsChecked,

    soundSubIsChecked,
    hellsKitchenSubIsChecked,
    vicinitySubIsChecked,
    soakSubIsChecked,
    towerVUSubIsChecked,
    allRestaurantsSubIsChecked,

    setAcceptPrivacyPolicyIsChecked,
    acceptPrivacyPolicyIsChecked,
    openPrivacyPolicy,
    submitUpdatePreferences,
    submittedPreferences,
    setUnsubCheckboxStates,
    unsubscribeClick,
  };
};
